import { render, staticRenderFns } from "./They-Said.vue?vue&type=template&id=7af5d75c&scoped=true"
import script from "./They-Said.vue?vue&type=script&lang=js"
export * from "./They-Said.vue?vue&type=script&lang=js"
import style0 from "./They-Said.vue?vue&type=style&index=0&id=7af5d75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af5d75c",
  null
  
)

export default component.exports